import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {  ChevronRight } from "lucide-react";

const Breadcrumb = ({ pages }) => {
  const { t } = useTranslation()
  const breadcrumbItems = [
    { name: t("routes.home"), link: "/" },
    ...(pages || [])
  ];

  return (
    <nav className="bg-[#F5F5F5] px-3 mb-4" aria-label="breadcrumb">
      <div className="container !py-3">
        <ol className="flex items-center flex-wrap w-full m-0 gap-1">
          {breadcrumbItems.map((item, index) => {
            const isLast = index === breadcrumbItems.length - 1;
            return (
              <li key={index} className="flex items-center">
                {/* Breadcrumb Item */}
                <div className={`
                  whitespace-nowrap max-lg:text-wrap
                  ${isLast
                    ? 'text-primary-tw font-medium'
                    : 'text-gray-400'
                  }
                `}>
                  {isLast ? (
                    <span
                      className="truncate max-w-[200px] block"
                      title={item.name || item}
                    >
                      {item.name || item}
                    </span>
                  ) : (
                    item.link ? (
                      <Link
                        to={item.link}
                        className="hover:text-gray-600 text-common-text transition-colors duration-200 truncate max-w-[150px] block"
                        title={item.name || item}
                      >
                        {item.name || item}
                      </Link>
                    ) : (
                      <button
                        onClick={() => window.history.back()}
                        className="hover:text-gray-600 transition-colors duration-200 truncate max-w-[150px]"
                        title={item.name || item}
                        type="button"
                      >
                        {item.name || item}
                      </button>
                    )
                  )}
                </div>

                {/* Separator - don't show after last item */}
                {!isLast && (
                  <span className={`mx-2 text-gray-400 flex-shrink-0 rtl:rotate-180`}>
                    <ChevronRight size={15} />
                  </span>
                )}
              </li>
            );
          })}
        </ol>
      </div>
    </nav>
  );
};

export default React.memo(Breadcrumb);